// this data is used to contruct analytics data layer
import { Inject, Injectable } from '@angular/core';
import { UserAgentService } from '@rd/core/services/user-agent/user-agent.service';
import { ENV } from '@rd/core/tokens/rd-lib.token';
import { WestpacAnalyticsService } from '@rd/wl/westpac/services/analytics/analytics.service';
import { EnvironmentType } from 'global-types';

@Injectable({
  providedIn: 'root',
})
export class BomAnalyticsService extends WestpacAnalyticsService {
  private analyticsUrls = {
    production:
      'https://www.bankofmelbourne.com.au/content/dam/public/launch/rrb/external/microsite/launch-0d9e0b1b517c/cf63e89810c4/20497110893c/launch-0d9e0b1b517c.min.js',
    staging:
      'https://www.bankofmelbourne.com.au/content/dam/public/launch/rrb/external/microsite/launch-0d9e0b1b517c/cf63e89810c4/20497110893c/launch-0d9e0b1b517c.min.js',
    local:
      'https://assets.adobedtm.com/launch-EN2508e087cb1a49dc961f9fa60d8b0520-development.min.js',
  };
  //
  protected analyticsUrl = '';
  protected offsiteScriptUrl =
    'https://www.bankofmelbourne.com.au/content/dam/bom/analytics/analytics_offsite.min.js';
  protected siteBrand = 'bom';

  constructor(
    @Inject(ENV) protected env: EnvironmentType,
    protected userAgentService: UserAgentService,
  ) {
    super(env, userAgentService);
    this.analyticsUrl = this.analyticsUrls[this.env] || '';
  }
}
